import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const komga = defineConnector({
  identifier: "komga",
  name: "Komga",
  tagLine: "Self-hosted comics and manga server",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) =>
    basicAuth({
      username: app.config.email,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Enter your Komga details",
      items: [
        {
          kind: "baseUrl",
          label: "Server URL",
          required: true,
          placeholder: "https://komga.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Komga instance.",
        },
        {
          kind: "input",
          label: "Email",
          required: true,
          target: { kind: "configuration", field: "email" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/v1/users/me`,
  },
});
